import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UserRole } from '../models/user.model';

/**
 * Guard factory : vérifie que l'utilisateur connecté possède l'un des rôles requis.
 * Usage dans les routes : canActivate: [roleGuard(UserRole.SUPER_ADMIN)]
 */
export function roleGuard(...allowedRoles: UserRole[]): CanActivateFn {
  return (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (!auth.isAuthenticated()) {
      router.navigate(['/auth'], { queryParams: { redirectTo: state.url } });
      return false;
    }

    const user = auth.currentUser();
    if (user && allowedRoles.includes(user.role)) {
      return true;
    }

    // Pas le bon rôle → rediriger vers le dashboard
    if (user?.role === UserRole.SUPER_ADMIN || UserRole.COMMERCIAL) {
      router.navigate(['/admin']);
      return false;
    }
    const redirectToParts = state.url.split('/').filter(Boolean);
    const redirectTo = redirectToParts?.[0] || '/home';
    router.navigate([redirectTo]);
    return false;
  };
}
